module.exports = __webpack_public_path__ + "assets/reorder-arrow-down-d1843b.svg";